module.exports = __webpack_public_path__ + "img/nocors2.d611593e.png";